import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    windowWidth: window.innerWidth,
  },
  getters: {
    isLoggedIn: state => () => {
      return !!state.user;
    },
    getUser: state => () => {
      return state.user;
    },
    getWindowWidth: state => () => {
      return state.windowWidth;
    },
  },
  mutations: {
    login(state, data) {
      state.user = data;
    },
    logout(state) {
      state.user = null;
    },
    setWindowWidth(state) {
      state.windowWidth = window.innerWidth;
    },
  },
  actions: {
    login(context, data) {
      context.commit('login', data);
    },
    logout(context) {
      context.commit('logout');
    },
  }
})
